module.exports = __webpack_public_path__ + "img/locked-documents.91e33ddb.svg";